"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _OptionalItem = _interopRequireDefault(require("./OptionalItem"));

var _BundlePage = require("../BundlePage");

function ServiceItem(_ref) {
  var merchandiseId = _ref.merchandiseId;

  var _useContext = (0, _react.useContext)(_BundlePage.BundleContext),
      state = _useContext.state,
      setState = _useContext.setState;

  var selectedServices = state.selectedServices;
  var onSelectedChange = (0, _react.useCallback)(function () {
    var updatedSelectedServices = selectedServices.includes(merchandiseId) ? selectedServices.filter(function (id) {
      return id !== merchandiseId;
    }) : [].concat((0, _toConsumableArray2.default)(selectedServices), [merchandiseId]);
    setState({
      selectedServices: updatedSelectedServices
    });
  }, [setState, merchandiseId, selectedServices]);
  return _react.default.createElement(_OptionalItem.default, {
    selected: selectedServices.includes(merchandiseId),
    onSelectedChange: onSelectedChange,
    merchandiseId: merchandiseId
  });
}

var _default = ServiceItem;
exports.default = _default;
module.exports = exports.default;